import * as Flags from '../Icons/Flags'

export interface ICountryFlagProps {
  countryCode?: string,
  width?: number,
}

export default function CountryFlag({ countryCode, width = 18 } : ICountryFlagProps) {
  if (!countryCode) {
    return null
  }

  const key = `Flag${countryCode.charAt(0).toUpperCase()}${countryCode.slice(1).toLowerCase()}` as keyof typeof Flags
  const FlagComponent = Flags[key]

  if (!FlagComponent) {
    return null
  }

  return <FlagComponent width={width} />
}
